export default "__VITE_ASSET__BwSeyx7H__"